module.exports = __webpack_public_path__ + "media/images/onestoremarisol-13a07ca2dde9075af573ce28708f7931.jpg";